import {
  getTowlotVehiclesRoutine,
  getTowlotVehicleRoutine,
  clearLocalTowlotVehiclesRoutine,
  clearLocalActiveTowlotVehicleRoutine,
  createTowlotVehicleRoutine,
  retryTowlotVehicleRoutine,
  getAuctionTowlotVehiclesRoutine,
  clearLocalAuctionTowlotVehiclesRoutine
} from 'actions';

const emptyAuctionTowlot = { data: [], pagination: { limit: 25, offset: 0, count: 0, total_count: 0 } };

export const initialState = {
  all: { data: [], pagination: { limit: 25, offset: 0, count: 0, total_count: 0 } },
  towlotVehicle: null,
  auction: emptyAuctionTowlot
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case getTowlotVehiclesRoutine.SUCCESS: {
      const { data: { towlot_vehicles, pagination } } = action.payload;

      return { ...state, all: { data: [...state.all.data, ...towlot_vehicles], pagination } };
    }
    case getAuctionTowlotVehiclesRoutine.SUCCESS: {
      const { data: { towlot_vehicles, pagination } } = action.payload;

      return {
        ...state,
        auction: {
          data: [...state.auction.data, ...towlot_vehicles],
          pagination
        }
      };
    }
    case getTowlotVehicleRoutine.SUCCESS: {
      const { data: { towlot_vehicle } } = action.payload;

      return { ...state, towlotVehicle: towlot_vehicle };
    }
    case clearLocalTowlotVehiclesRoutine.SUCCESS: {
      return { ...state, all: initialState.all };
    }
    case clearLocalAuctionTowlotVehiclesRoutine.SUCCESS: {
      return { ...state, auction: emptyAuctionTowlot };
    }
    case clearLocalActiveTowlotVehicleRoutine.SUCCESS: {
      return { ...state, towlotVehicle: null };
    }
    case createTowlotVehicleRoutine.SUCCESS: {
      const { data: { towlot_vehicle } } = action.payload;

      return { ...state, towlotVehicle: towlot_vehicle };
    }
    case retryTowlotVehicleRoutine.SUCCESS: {
      const { data: { towlot_vehicle } } = action.payload;

      return {
        ...state,
        towlotVehicle: towlot_vehicle,
        all: {
          ...state.all,
          data: state.all.data.map((row) => (String(row.id) === String(towlot_vehicle.id) ? { ...row, ...towlot_vehicle } : row))
        }
      };
    }
    default: {
      return state;
    }
  };
};

export default reducer;
